export default __webpack_public_path__ + "3a168f7edf50d63d1505b00d1dd4216f.png";